import { useEffect } from 'react';

const RedirectComponent = () => {
    useEffect(() => {
        if (__isBrowser__) {
            window.location.href = window.location.pathname;
        }
    }, []);

    return false;
};
export default RedirectComponent;
